import React, { Component } from 'react';
import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button, FormText
} from 'reactstrap';

/**
* Shows a freshly created or rotated API key (VD-725).
* The plain key is returned by the API exactly once, so the modal cannot be
* dismissed by clicking the backdrop or pressing escape - the user has to
* confirm they copied it. The key lives in the parent state only while this
* modal is open, it is never written to a store or to localStorage.
*/
class ApiKeyRevealModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            copied: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.apiKey !== this.props.apiKey && this.state.copied) {
            this.setState({ copied: false });
        }
    }

    copy = () => {
        let value = this.props.apiKey;

        if (!value) {
            return;
        }

        let fallback = () => {
            if (this.input) {
                this.input.removeAttribute('readonly');
                this.input.select();
                this.input.setSelectionRange(0, value.length);
                document.execCommand('copy');
                this.input.setAttribute('readonly', 'readonly');
            }
        };

        // navigator.clipboard is unavailable on plain http, fall back to execCommand
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(value).then(
                () => this.setState({ copied: true }),
                () => {
                    fallback();
                    this.setState({ copied: true });
                }
            );
        } else {
            fallback();
            this.setState({ copied: true });
        }
    }

    render() {
        return (
            <Modal isOpen={!!this.props.apiKey} backdrop="static" keyboard={false} size="lg">
                <ModalHeader>
                    {'The key is shown only once'.translate(this.props.lang)}
                </ModalHeader>
                <ModalBody>
                    {this.props.name ?
                        <p style={{ marginBottom: 8 }}>
                            <strong>{this.props.name}</strong>
                        </p>
                        : null}

                    <div className="api-key-reveal">
                        <input
                            ref={(node) => this.input = node}
                            type="text"
                            className="form-control"
                            readOnly
                            value={this.props.apiKey || ''}
                            onFocus={(e) => e.target.select()}
                        />
                        <Button color="primary" onClick={this.copy}>
                            {this.state.copied ? 'Copied'.translate(this.props.lang) : 'Copy'.translate(this.props.lang)}
                        </Button>
                    </div>

                    <FormText color="muted" style={{ marginTop: 4 }}>
                        {'Send it to the client as the'.translate(this.props.lang)} <code>X-API-KEY</code> {'request header.'.translate(this.props.lang)}
                    </FormText>

                    <p className="api-key-warning">
                        {'Copy the key now and store it somewhere safe. It cannot be read again later - if it is lost, the only option is to rotate the key and hand out a new one.'.translate(this.props.lang)}
                    </p>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => this.props.onClose()}>
                        {'I have copied the key'.translate(this.props.lang)}
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default ApiKeyRevealModal;
